import { connect } from "react-redux";
import Footer from "../components/Footer";

export default connect(
  (state, props) => ({}),
  (dispatch, props) => ({})
)(Footer);
